import * as React from 'react';
import { Body1, Button, UIHeading1 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import * as styles from './styles.css';
import { useIsMounted } from '../../hooks/useIsMounted';

export interface ICompareBannerProps {
  onClick: () => void;
}

export const CompareBanner = ({ onClick }: ICompareBannerProps) => {
  // Фон баннера грузим после гидрации, чтобы он не отнимал канал у LCP-картинки на первом экране
  const isMounted = useIsMounted();

  return (
    <div className={styles['container']}>
      <div className={styles['content-container']}>
        <div className={styles['text-container']}>
          <UIHeading1>ЖК познаются в сравнении</UIHeading1>
          <Body1>Цены, метраж, инфраструктура: покажем всё важное</Body1>
        </div>
        <Button onClick={onClick} maxWidth={216}>
          Как работает сравнение
        </Button>
      </div>

      <div
        className={clsx(styles['image'], isMounted && styles['image--with-image'])}
        data-testid="BannerImage"
        data-image-loaded={isMounted}
        aria-hidden="true"
      />
    </div>
  );
};
